import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';

const Module = styled.div`
	margin: 15rem auto;
	padding: 1.6rem;
	background: ${props => props.theme.gr1};
	position: relative;
	max-width: 100vw;

	${rmq('ml')} {
		padding: 1.6rem 0 0;
		margin: 10rem auto;

		&:last-child {
			margin: 6rem auto;
		}
	}

	&::before,
	&::after {
		content: '';
		background: ${props => props.theme.gr1};
		position: absolute;
		width: 90%;
		height: 90%;
		transform: rotateZ(5deg);
		z-index: -1;
		left: 0.5rem;
		top: -1rem;

		${rmq('820')} {
			width: 85%;
		}
		${rmq('t')} {
			width: 80%;
		}
		${rmq('700')} {
			width: 60%;
			left: 1rem;
			top: -1.5rem;
			transform: rotateZ(2deg);
		}
		${rmq('275')} {
			display: none;
		}
	}

	&::after {
		transform: rotateZ(15deg);
		left: 3rem;
		top: 0.1rem;

		${rmq('900')} {
			left: 8rem;
			top: -1.5rem;
			transform: rotateZ(6deg);
		}
		${rmq('ms')} {
			left: 6rem;
		}
		${rmq('275')} {
			display: none;
		}
	}

	&:hover {
		/* transform: scale(1.01); */
		transition: all 0.4s ease;
		box-shadow: 0 0 12rem 0 rgba(22, 22, 22, 0.4);
	}
`;

const Inner = styled.div`
	background: rgba(255, 255, 255, 0.95);
	background: ${props => props.theme.white};
	padding: 1.6rem;

	${rmq('ml')} {
		padding: 1.6rem 0.6rem;
	}
`;

export default ({ children }) => (
	<Module>
		<Inner>{children}</Inner>
	</Module>
);
